import type { TaxScenarioInput, FilingStatus } from '@/tax/types';

export interface StepProps {
  input: TaxScenarioInput;
  onChange: <K extends keyof TaxScenarioInput>(key: K, value: TaxScenarioInput[K]) => void;
  filingStatus?: FilingStatus;
}

export interface WizardStepConfig {
  id: string;
  label: string;
  shortLabel: string;
}

export const WIZARD_STEPS: WizardStepConfig[] = [
  { id: 'filing', label: 'Filing Status & Personal', shortLabel: 'Filing Info' },
  { id: 'income', label: 'Income Sources', shortLabel: 'Income' },
  { id: 'business', label: 'Schedule C — Business', shortLabel: 'Business' },
  { id: 'rental', label: 'Schedule E — Rental & K-1', shortLabel: 'Rental & K-1' },
  { id: 'deductions', label: 'Deductions & Adjustments', shortLabel: 'Deductions' },
  { id: 'credits', label: 'Credits & Payments', shortLabel: 'Credits' },
  { id: 'strategies', label: 'Strategies & Comparison', shortLabel: 'Strategies' },
];
